<template>
  <div id="app">
    <div class="over-all" v-if="isSetting"></div>
    <router-view />
  </div>
</template>

<script>
import configMixin from "@/mixin/config";
import authService from "@/services/authService";
import { common } from "@/model/common";

export default {
  name: "App",
  components: {},
  mixins: [configMixin],
  created() {
    this.prefetchLangs();
  },
  methods: {
    // 启动时统一加载一次 langs（专门为多语言切换器）
    // register.js 也会调 getJsonParams（拿业务数据），两次调用的 i18n 拦截器是 idempotent 的
    prefetchLangs() {
      // 从 URL/cookie 中拿到 memberFormId（页面进入时已有）
      let memberFormId =
        (common && common.memberFormId) ||
        (typeof window !== "undefined" &&
          window.$sk &&
          window.$sk.memberFormId);
      // 兜底：从 URL 取
      if (!memberFormId && typeof window !== "undefined" && window.location) {
        const match = window.location.href.match(/formId[=/]([^&/?#]+)/);
        if (match) memberFormId = decodeURIComponent(match[1]);
      }
      if (!memberFormId) return;
      authService
        .getJsonParams({
          id: memberFormId,
          type: "memberForm",
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
//#app {
//  height: 100%;
//}
</style>
